
const Footer = () => {
  return (
    <footer id="company">
      <div style={{ padding: '0px 0px 40px 0px', marginTop: '-20px', textAlign: 'center' }}>
        <p>Pioneering AI-powered steel development. Born from research at KTH Royal Institute of Technology, we're making steel innovation faster, smarter, and more sustainable.</p>
      </div>
      <div className="footer-bottom">
        <span className="footer-copy">© 2026 Ferritico AB. All rights reserved.</span>
        <div className="footer-links">
          <a href='https://linkedin.com/company/ferritico' target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="/privacy-policy" >Privacy Policy</a>
          <a href="/legal">Legal Notice</a>
          <a href="#contact">Contact</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
